import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=470d3cc2"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./MainMenu.vue?vue&type=style&index=1&id=470d3cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports